import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { StorageService } from 'src/app/core/services/storage.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppPaymentTVService } from 'src/app/core/services/app-payment-tv.service';
import { CONST_AWS_API, API, COUNTRIES_LIST, MERCH_API } from '../../../../core/constants';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { API as AWS_API } from 'aws-amplify';
import { ValidationService } from 'src/app/core/services/validation.service';
import { SearchCountryField, CountryISO } from 'ngx-intl-tel-input-gg';
import { PaymentService } from 'src/app/core/services/payment.service';
import { MerchCartService } from 'src/app/core/services/merch-cart.service';
declare let window: any;
declare var fbq: any;
@Component({
  selector: 'app-shipping-product',
  templateUrl: './shipping-product.component.html',
  styleUrls: ['./shipping-product.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ShippingProductComponent implements OnInit {

  userInfo: any = {};
  userInfoSubscription: Subscription;
  showBillingForm: boolean = false;
  addressList: any = [];
  addressListInfoSubscr: Subscription;
  isStateOptional: boolean;
  countriesList = COUNTRIES_LIST;
  billingCountry: any = {};
  shippingCountry: any = {};
  options: {};
  countryChanged: boolean = true;
  billingForm: FormGroup;
  shippingForm: FormGroup;
  currentLocation: any;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  selectedCountry: any = "US";
  address: string;
  pastedText: any;
  showShippingForm: boolean = false;
  shippingCountriesList = [];
  newShippingForm: boolean = false;
  selectedShippingAddress: any = {};
  selectedBillingAddress: any = {};
  cartId: any;
  cartProductsList: any = [];
  productsTotal: number = 0;
  productCurrency: any;
  showAllProducts: boolean = false;
  isDiscountApplied: boolean = false;
  couponCode: any;
  discountData:any;
  shippingCost: number = 0;
  shippingChrg: number = 0;
  getCurrency: any;
  digitalProducts: any = [];
  selectedCard: any;
  processingFee: number = 0;
  codes: any;
  shippingCodes: any;
  taxAmount: number = 0;
  finalAmount: number = 0;
  amt_without_pf: number = 0;
  taxPercentage: number = 0;
  incl: any;
  invoice_id: any;
  shippingJSON = [];
  selectedTransaction: any;
  currentBlock: String = 'Merch Market';
  shippingList: any = [];
  transactionInfoSubscr: Subscription;
  transactionInfo: any;
  card: any;
  creator_currency: any;
  selectedCardInfoSubscr: Subscription;
  email: any;
  discountAmount: number = 0;
  assets_url = environment.assets_url;
  merchUrl: any;
  isMobPaymentSuccess: boolean = false;
  curExchangeRate: any;
  activeBlock: String = '';
  clientDetails: { template: number; name: string; slug: string; network_logo: string; header_logo: string; footer_logo: string; crypto_token: string; crypto_symbol: string; privacy_mail: string; market_mail: string; info_mail: string; support_mail: string; address: { line1: string; line2: string; city: string; state: string; zip: string; }; };
  cryptoToken: string;
  cryptoSymbol: string;
  USD_Rates: any;
  totalAmount: Subscription;
  currency_for_totAmt: any;
  amt_without_pf1: any;
  crypto_amount: any;
  sliced_crypto_amount: number;
  deviceInfo: string = 'web';
  redirectMobileURL =  environment.CONSUMER_PORTAL + "network-market/market/cancel-payment";
  shippingCountries: string[] = [];
  getCartProductsInfo:Subscription;
  getCartProductsList:any;
  organization_product_details: any[] = [];
  channelName: any;
   settingsData: any = {};
  settingsDataSubscription: Subscription;
  networkGroupId:any;
  organizationId: any;
  performerInfoSubscription!: Subscription;

  constructor(
    private appPaymentService: AppPaymentTVService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private commonSubscribeService: CommanSubscribeService,
    private loader: NgxUiLoaderService,
    private activatedRoute: ActivatedRoute,
    private storageService: StorageService,
    private cd: ChangeDetectorRef,
    private paymentService: PaymentService,
    private merchCartService: MerchCartService,
    private router: Router,

    public dialog: MatDialog,
    private route:ActivatedRoute) {
    this.getCurrency = this.storageService.getItem('currency');
    let locInfo = this.commonSubscribeService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
    if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
      this.commonSubscribeService.getCurrentLocation((val: any, json: any) => {
        if (val == "fail") {
          this.currentLocation = {};
        } else {
          this.currentLocation = json;
        }
        this.getCurrency = this.getCurrency ? this.getCurrency : this.currentLocation["currency"]["code"];
      });
    } else if(this.currentLocation && Object.keys(this.currentLocation).length > 0){
      this.getCurrency = this.getCurrency ? this.getCurrency : this.currentLocation["currency"]["code"];
    }
  }

  ngOnInit() {
    this.deviceInfo = this.commonSubscribeService.getMobileOperatingSystem();
    this.organizationId = this.commonSubscribeService.perfomerInfoData?.data?.Data?.[0]?.organization_id;
    this.performerInfoSubscription = this.commonSubscribeService.getPerfomerInfo().subscribe(response => {
      this.organizationId = response?.data?.Data?.[0]?.organization_id;
    });
    this.buildBillingForm();
    this.buildShippingForm();
    this.cartId = this.activatedRoute.snapshot.params.cart_id;
    if (!this.activatedRoute.snapshot.queryParams.token) {
      this.getcartProductsList();
    }
    this.settingsDataSubscription = this.commonSubscribeService.getICWebpageThemeSettings().subscribe(async (response) => {
      this.settingsData = response;
    });
    this.settingsData = this.commonSubscribeService.icWebpageSettingsData;
    if (this.activatedRoute.snapshot.queryParams.token) {
      console.log("this.activatedRoute.snapshot.queryParams.token", this.activatedRoute.snapshot.queryParams.token);
      this.merchUrl = environment.CONSUMER_PORTAL + "network-market/market";
      this.getCurrency = this.getParam('currency');
      this.getUserInfo(() => {
        this.getcartProductsList();
      });
    }
    this.clientDetails = environment.clientDetails;
    this.cryptoToken = this.clientDetails.crypto_token;
    this.cryptoSymbol = this.clientDetails.crypto_symbol;
    this.commonSubscribeService.getCurrencyRates("USD",result=>{
      this.USD_Rates = result;
    });
    this.totalAmount = this.commonSubscribeService.getTotalAmount().subscribe(response => {
      this.currency_for_totAmt = response.currency;
      this.amt_without_pf1 = response.amt_without_pf;
      this.crypto_amount = this.commonSubscribeService.convertToCryptoAmount(this.amt_without_pf1,this.USD_Rates[this.currency_for_totAmt])
      this.sliced_crypto_amount = Math.trunc(this.crypto_amount * Math.pow(10, 3))/Math.pow(10, 3);
    })

    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
      this.email = this.userInfo.email;
    });
    this.email = this.userInfo.email;
    this.addressListInfoSubscr = this.commonSubscribeService.getAddressList().subscribe(response => {
      this.addressList = response;
      if (this.addressList.shippingAddress.length > 0) {
        let shippingAdd = this.addressList.shippingAddress.filter(a => a.shippingAddress);
        this.newShippingForm = shippingAdd.length > 0 ? true : false;
        let selectedAddress = this.addressList.shippingAddress.filter(a => a.defaultShippingAddress);
        this.selectedShippingAddress = selectedAddress.length > 0 ? selectedAddress[0] : {};
      } else if (this.addressList.shippingAddress.length == 0) {
        this.newShippingForm = true;
      }
      if (this.addressList.billingAddress.length > 0) {
        let billingAdd = this.addressList.billingAddress.filter(a => a.billingAddress);
        this.showBillingForm = billingAdd.length > 0 ? true : false;
        if (this.showBillingForm) {
          this.commonSubscribeService.formsValidationSubject.next(false);
        }
        let selectedAddress = this.addressList.billingAddress.filter(a => a.defaultBillingAddress);
        this.selectedBillingAddress = selectedAddress.length > 0 ? selectedAddress[0] : {};
        if ((this.billingForm.valid && (this.shippingForm.valid || !this.showShippingForm)) || ((((Object.keys(this.selectedShippingAddress).length > 0 || this.shippingForm.valid) || !this.showShippingForm) && (Object.keys(this.selectedBillingAddress).length > 0 || this.billingForm.valid)))) {
          if (this.digitalProducts.length > 0 && !this.email) {
            this.toastr.error("Please enter email");
            this.commonSubscribeService.formsValidationSubject.next(false);
            return;
          }
          this.commonSubscribeService.formsValidationSubject.next(true);
          if (Object.keys(this.selectedBillingAddress).length > 0) {
            let country;
            COUNTRIES_LIST.forEach(element => {
              if (element.alpha3code == this.selectedBillingAddress.country_code) {
                country = element;
              }
            });
            let zip = this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : ""
            let cName = this.getBillingValue.country.name ? this.getBillingValue.country.name : this.selectedBillingAddress && this.selectedBillingAddress.country ? country ? country.name : this.selectedBillingAddress.country : ""
            this.commonSubscribeService.validateZip(zip, cName, (result) => {
              if (result.status) {
                this.codes = result;
                let country = COUNTRIES_LIST.filter(country => country.alpha2code == this.codes.country);
                this.codes.country = country[0].alpha3code;
                let zipCode = this.showShippingForm || (this.selectedShippingAddress && this.selectedShippingAddress.zip) ? this.getShippingValue.zip : this.selectedShippingAddress && this.selectedShippingAddress.zip ? this.selectedShippingAddress.zip : zip;
                this.getTaxPercentage(zipCode, () => {
                  if(this.digitalProducts && this.digitalProducts.length != this.cartProductsList.length){
                    this.shippingCost = this.shippingChrg;
                  } else{
                    this.shippingCost = 0;
                  }
                  this.finalAmount = this.productsTotal + this.taxAmount + this.shippingCost - this.discountAmount;
                  this.amt_without_pf = this.finalAmount = Number(this.finalAmount.toFixed(2));
                  // Processing fee only applies once a payment mode is chosen, and not for wallet/crypto (calFee() follows the same rule).
                  if (this.selectedTransaction && this.selectedTransaction != 'wallet' && this.selectedTransaction != 'crypto') {
                    this.processingFee = (this.finalAmount * (environment.processing_fee / 100)) + environment.fee_percentage;
                    this.processingFee = Number(this.processingFee.toFixed(2));
                    this.finalAmount = this.finalAmount + this.processingFee;
                  } else {
                    this.processingFee = 0;
                  }
                  this.finalAmount = Number(this.finalAmount.toFixed(2));
                  let data = {
                    "total_amount": this.finalAmount,
                    "currency": this.productCurrency,
                    "processing_fee": this.processingFee ? this.processingFee : undefined,
                    "amt_without_pf": this.amt_without_pf
                  }
                  this.commonSubscribeService.totalAmountSubject.next(data);
                });
              } else {
                this.toastr.error('Invalid zip code');
              }
            });
            if(this.selectedTransaction){
              let val = {'selectedTransaction':this.selectedTransaction};
              this.calFee(val);
            }
          }
        }
        if (this.showBillingForm) {
          this.buildBillingForm();
        }
      } else if (this.addressList.billingAddress.length == 0) {
        this.showBillingForm = true;
      }
      if (this.showBillingForm && this.addressList.billingAddress.length > 0) {
        this.sameBillingAddress = false;
      }
    });
    // Debounced: validation geocodes the zip, and validating every keystroke
    // ("5", "50", ...) made Google return ZERO_RESULTS → "Invalid zip code".
    this.shippingForm.valueChanges.pipe(debounceTime(800)).subscribe(val => {
      if (this.shippingForm.invalid) {
        this.commonSubscribeService.formsValidationSubject.next(false);
      } else if (this.shippingForm.valid) {
        this.proceedWithAddress();
        this.commonSubscribeService.formsValidationSubject.next(true);
      }
    })

    this.billingForm.valueChanges.pipe(debounceTime(800)).subscribe(val => {
      if (this.billingForm.invalid) {
        this.commonSubscribeService.formsValidationSubject.next(false);
      } else if (this.billingForm.valid) {
        this.proceedWithAddress();
        this.commonSubscribeService.formsValidationSubject.next(true);
      }
    })

    this.selectedCardInfoSubscr = this.commonSubscribeService.getSelectedCardInfo().subscribe(response => {
      this.selectedCard = response;
    });

    this.transactionInfoSubscr = this.commonSubscribeService.getTransactionInfo().subscribe(response => {
      this.transactionInfo = response;
      this.card = this.transactionInfo["card"];
      if (this.selectedCard && this.selectedCard.id) {
        this.makePayment('card');
      } else {
        this.makePayment();
      }
    })

    this.getCartProductsInfo = this.commonSubscribeService.getCartProductInfo().subscribe(response => {
      this.getCartProductsList = response;
       this.organization_product_details = this.getCartProductsList?.map((item: any) => ({
        organization_id: item.organization_id,
        product_id: item.product_id
      }));
    })

    this.channelName = this.route.parent.snapshot.params['channelName'];
    console.log("Channel Name in Shipping Product: ", this.channelName);
    const parent = this.route.parent;

  if (parent) {
    this.channelName = parent.snapshot.paramMap.get('channelName');
  } else {
    console.warn("No parent route found for Shipping Product");
    this.channelName = null;
  }


    this.route.queryParams.subscribe(params => {
      if (params['code']) {
        this.couponCode = params['code'];
      }
    });
  }

  getParam(param) {
    try {
      let url = decodeURIComponent(location.href).split("?");
      let queryParams = url[1].split("&");
      let params = {};
      if (queryParams && queryParams.length > 0) {
        queryParams.forEach(p => {
          let p1 = p.split("=");
          params[p1[0]] = p1[1];
        });
      }
      return params[param];
    } catch (e) {
      console.log(e);
      return this.activatedRoute.snapshot.queryParamMap.get(param);
    }
  }

  getUserInfo(callback) {
    let id = this.getParam('user_id')
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        // "Authorization": `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        "user_id": id,
        "organization_id": this.organizationId
      }
    }
    // this.loader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER_BY_ID, data).then(response => {
      // this.loader.stop();
      if (response.data.user) {
        let token = this.getParam('token');
        if (token) {
          response.data.user.access_token = token
        } else {
          response.data.user.access_token = response.data.user.session_token;
        }
        this.userInfo = this.commonSubscribeService.userInfo = response.data.user;
        this.commonSubscribeService.sendUserInfo(this.userInfo);
      }
      callback();
    }).catch(error => {
      // this.loader.stop();
    });
  }

  getcartProductsList() {
    let url = MERCH_API.UPDATE_CART_CURRENCY;
    this.appPaymentService.postRequest(url, { "cart_id": this.cartId, "currency": this.getCurrency }).subscribe(response => {
      if (response.status === 0) {
        this.cartProductsList = response.products;
        if (this.cartProductsList.length > 0) {
          if (this.showShippingForm && ((this.addressList.shippingAddress && this.addressList.shippingAddress.length == 0) || this.userInfo.is_guest)) {
            this.newShippingForm = true;
          }
          this.shippingJSON = [];
          this.cartProductsList.forEach(element => {
            element.product_info = JSON.parse(element.product_data);
            element.product_img = element.product_info.media_url && element.product_info.media_url[0] ? element.product_info.media_url[0] : this.assets_url + 'merch-default-image.png';
            element.totalPrice = element.quantity * element.price;
            this.productCurrency = element.product_info.currency_type;
            this.productsTotal += element.totalPrice;
            this.networkGroupId = element.product_info.network_group_id;
            element.shippingJSON = JSON.parse(element.product_info.shipping_json);
            if (element.shippingJSON && element.shippingJSON.length > 0) {
              this.shippingJSON = this.shippingJSON.concat(JSON.parse(element.product_info.shipping_json));
              const uniqueCountryCodes = [...new Set(this.shippingJSON.map(e => e.country_name))];
                // Map to country objects only (no string codes)
                this.shippingCountries = uniqueCountryCodes
                    .map(countryCode => {
                        return COUNTRIES_LIST.find(country => 
                            country.alpha2code === countryCode || country.alpha3code === countryCode
                        );
                    })
                    .filter(Boolean); // Remove any undefined entries
              }
            this.productsTotal = Number(this.productsTotal.toFixed(2));
            if (element.product_info.attributes && element.product_info.attributes.length > 0) {
              element.product_info.attributes.forEach(attr => {
                attr.attributesList.forEach(att => {
                  if (att['is_selected']) {
                    attr['selected_attr'] = att.value;
                  }
                });
              });
            }
          });
          this.curExchangeRate = this.cartProductsList[0].currency_rate;
          this.digitalProducts = this.cartProductsList.filter(a => a.product_info.is_digital);
          this.showShippingForm = this.digitalProducts.length != this.cartProductsList.length ? true : false;
          this.shippingCost = 0;
          if (this.shippingJSON && this.shippingJSON.length > 0) {
            this.shippingJSON.forEach(e => {
              if (e.country_name == this.currentLocation.country_code2) {
                this.shippingCost += Number(e.shipping_cost);
              }
            })
          }
          if (this.curExchangeRate != 1){
            this.shippingChrg = this.shippingCost = this.shippingCost * this.curExchangeRate;
          } else {
            this.shippingChrg = this.shippingCost;
          }
          if(this.digitalProducts && this.digitalProducts.length != this.cartProductsList.length){
            this.shippingCost = this.shippingChrg;
          } else{
            this.shippingCost = 0;
          }
          this.finalAmount = this.productsTotal + this.shippingCost;
          this.commonSubscribeService.cartProductsSubject.next(this.cartProductsList);

            if(this.cartProductsList && this.cartProductsList.length > 0){
              // this.creator_currency = this.cartProductsList[0].product_info.currency_type;
              let allUSD = false, allGBP = false;
              allUSD = this.cartProductsList.every(pr => pr.creator_currency === "USD");
              allGBP = this.cartProductsList.every(pr => pr.creator_currency === "GBP");
              if(allUSD)
                this.creator_currency = "USD";
             else if(allGBP)
                this.creator_currency = "GBP";
              else
                this.creator_currency = "USD";
            }
          let streamInfo = { "currency_type": "USD" }
          this.commonSubscribeService.sendSlugData(streamInfo);
          if ((Object.keys(this.selectedBillingAddress).length > 0) && (!this.showShippingForm && Object.keys(this.selectedShippingAddress.length > 0))) {
            this.commonSubscribeService.formsValidationSubject.next(true);
          }
        } else {
          if (this.isMerchandiseFlow()) {
            this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName) + '/merchandise/merch-list']);
        } else {  
          this.router.navigateByUrl("network-market/market");
        }
      }
      } else if (response.status === 1) {
        this.toastr.error(response.message)
      }
    }, error => {
      this.loader.stop();
      this.toastr.error(error?.error)
    });

  }


  toggleProducts() {
    this.showAllProducts = !this.showAllProducts;
  }
 
  get businessPhoneValue() {
    return this.shippingForm.controls['phone_number'];
  }

  buildBillingForm() {
    this.billingForm = this.formBuilder.group({
      address1: ['', Validators.required],
      address2: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', [Validators.required, ValidationService.autoCompleteValueSelected(COUNTRIES_LIST, 'name')]],
      zip: ['', Validators.required],
    });
    if (!this.showShippingForm && this.currentLocation) {
      this.countriesList.forEach(country => {
        if (country.alpha2code == this.currentLocation.country_code2) {
          // this.countryChanged = false
          this.selectedCountry = country.alpha2code;
          this.billingForm.patchValue({
            country: country
          });
        }
      })
    }
  }

  buildShippingForm() {
    this.shippingForm = this.formBuilder.group({
      address1: ['', Validators.required],
      address2: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', [Validators.required, ValidationService.autoCompleteValueSelected(COUNTRIES_LIST, 'name')]],
      zip: ['', Validators.required],
      phone_number: ['', [Validators.required]]
    });
    // this.commonSubscribeService.getCurrentLocation((val: any, json: any) => {
    //   if (val == "fail") {
    //     this.currentLocation = {};
    //   } else {
    //     this.currentLocation = json;
        if (this.currentLocation) {
          this.countriesList.forEach(country => {
            if (country.alpha2code == this.currentLocation.country_code2) {
              this.countryChanged = false
              this.selectedCountry = country.alpha2code;
              this.billingForm.patchValue({
                country: country
              });
              this.shippingForm.patchValue({
                country: country
              });
              this.shippingCountriesList.push(country);
              this.shippingList = this.shippingCountriesList;
              this.options = {
                types: [],
                componentRestrictions: { country: country.alpha2code }
              };
              this.checkState(country);
              setTimeout(() => { this.countryChanged = true });
              // if (this.settingsJSON && this.settingsJSON.country_wise_shipping && this.showShippingForm) {
              //   this.checkShippingPrice('default');
              // }
            }
          });
        }
    //   }
    // });
  }

  prepare() {
    if (this.currentLocation) {
      this.countriesList.forEach(country => {
        if (country.alpha2code == this.currentLocation.country_code2) {
          this.countryChanged = false
          this.selectedCountry = country.alpha2code;
          this.billingForm.patchValue({
            country: country
          });
          this.shippingForm.patchValue({
            country: country
          });
          this.options = {
            types: [],
            componentRestrictions: { country: country.alpha2code }
          };
          this.checkState(country);
          setTimeout(() => { this.countryChanged = true });
        }
      });
    }
  }

  checkState(country) {
    if (country && country.stateless == "yes") {
      this.billingForm.get("state").setValidators([]);
      this.billingForm.get("state").updateValueAndValidity();
      this.shippingForm.get("state").setValidators([]);
      this.shippingForm.get("state").updateValueAndValidity();
    }
  }

  selectCountry(country, formType) {
    this.countryChanged = false
    this.billingCountry = country.value;
    this.shippingCountry = country.value;
    if (formType == 'shippingForm')
      this.selectedCountry = country.value.alpha2code;
    this.options = {
      types: [],
      componentRestrictions: { country: country.value.alpha2code }
    };
    if (formType == 'billingForm') {
      this.billingForm.patchValue({
        address1: "",
        address2: "",
        city: "",
        state: "",
        // country: "",
        zip: ""
      });
    } else {
      this.shippingForm.patchValue({
        address1: "",
        address2: "",
        city: "",
        state: "",
        // country: "",
        zip: "",
        phone_number: ""
      });
    }
    this.checkState(country.value);
    setTimeout(() => { this.countryChanged = true });
  }

  displayCountryName(option) {
    return option ? option.name : undefined;
  }

  filterCountry(form) {
      if (form == "getShippingValue") {
          this.shippingCountriesList = [...this.shippingCountries]; // Use shippingCountries, not shippingList
      }
      // Get the form control value properly
      const formControl = form == "getShippingValue" ? this.shippingForm.get('country') : this.billingForm.get('country');
      const inputValue = formControl?.value;
      
      if (inputValue && typeof inputValue === 'string') {
          let countriesList = form == "getShippingValue" ? 
              [...this.shippingCountries] : // Use original shippingCountries
              [...COUNTRIES_LIST];
          const filterValue = inputValue.toLowerCase();
          if (form == "getShippingValue") {
              this.shippingCountriesList = countriesList.filter(option => 
                  option.name.toLowerCase().indexOf(filterValue) >= 0
              );
          } else {
              this.countriesList = countriesList.filter(option => 
                  option.name.toLowerCase().indexOf(filterValue) >= 0
              );
          }
      } else {
          // Reset to original list if no valid input
          if (form == "getShippingValue") {
              this.shippingCountriesList = [...this.shippingCountries];
          } else {
              this.countriesList = [...COUNTRIES_LIST];
          }
      }
  }

  getSelectedAddress(val, formType?) {
    var myAddress = {
      name: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      country: '',
      zip: '',
      copy: false
    };
    let street = val && val.formatted_address ? val.formatted_address.split(',') : val.split(',');
    this.address = street[0];
    this.loader.start();
    if (val && val.formatted_address)
      val = val.formatted_address
    else
      val = this.pastedText;
    myAddress.address1 = this.address;
    if (val) {
      this.commonSubscribeService.getAddress(val, (result) => {
        this.loader.stop();
        if (result) {
          let place = {
            address_components: result['results'][0]['address_components'],
            geometry: result['results'][0].geometry
          }
          if (place && place.address_components) {
            place.address_components.forEach(element => {
              if ((element.types[0] == "sublocality_level_1" || element.types[0] == "premise") && element.long_name)
                myAddress.address2 = element.long_name;

              if ((element.types[0] == "locality" || element.types[0] == "postal_town") && element.long_name)
                myAddress.city = element.long_name;
              if ((element.types[0] == "administrative_area_level_1" || element.types[0] == "administrative_area_level_2") && element.long_name)
                myAddress.state = element.long_name;
              if (element.types[0] == "country" && element.long_name)
                myAddress.country = element.long_name;
              if (element.types[0] == "postal_code" && element.long_name)
                myAddress.zip = element.long_name;
            });
          }
          let country = myAddress.country && val ? COUNTRIES_LIST.find(c => c.name === myAddress.country) : COUNTRIES_LIST.find(c => c.name === myAddress.country);
          if (country.alpha2code != this.currentLocation.country_code2 && formType == 'shippingForm') {
            this.toastr.error("Shipping is not available in your region");
            this.buildShippingForm();
            return;
          }
          this.getBillingAddress(myAddress, formType);
        }
      });
      // }).catch((error)=>{
      //   this.loader.stop();
      // });
    }
  }

  getBillingAddress(myAddress, formType, val?) {
    let formVal = formType == 'billingForm' ? this.billingForm : this.shippingForm;
    let country = myAddress.country && val ? COUNTRIES_LIST.find(c => c.name === myAddress.country.name) : COUNTRIES_LIST.find(c => c.name === myAddress.country);
    formVal.patchValue({
      address1: myAddress.address1 ? myAddress.address1 : this.address,
      address2: myAddress.address2,
      city: myAddress.city,
      state: myAddress.state,
      country: country ? country : {},
      zip: myAddress.zip
    });
    // if (this.billingForm.valid){
    //   this.proceed();
    // }
  }

  sameBillingAddress = false;
  // "Same as shipping address" sits on the page background (merchandise_bg_main_color), outside the
  // coloured address forms, but global rules force checkbox labels to the theme font colour (white)
  // and the tick to black. Use the network's own page text colour, falling back to black/white when
  // that pair isn't readable; the tick contrasts with the box. Unknown colours keep today's styling.
  get sameAsShippingColors(): { label?: string; box?: string; tick?: string } {
    const bg = this.toRgb(this.settingsData?.merchandise_bg_main_color);
    if (!bg) return {};
    const fg = this.toRgb(this.settingsData?.merchandise_font_main_color);
    const readable = fg && this.contrastRatio(fg, bg) >= 3;
    const label = readable ? this.settingsData.merchandise_font_main_color : (this.luminance(bg) > 0.5 ? '#000000' : '#ffffff');
    const box = this.toRgb(label);
    return { label, box: label, tick: this.luminance(box) > 0.5 ? '#000000' : '#ffffff' };
  }

  // Saved-address / "Add new" radios (app-default-address) sit on both the page background and the
  // address cards (form_bg_color). Use the network page text colour when readable on both,
  // otherwise whichever of black/white reads better on both. Unknown page colour keeps today's styling.
  get addressRadioColor(): string {
    const surfaces = [this.settingsData?.merchandise_bg_main_color, this.settingsData?.form_bg_color]
      .map(c => this.toRgb(c)).filter(Boolean);
    if (!this.toRgb(this.settingsData?.merchandise_bg_main_color)) return undefined;
    const minContrast = (c: number[]) => Math.min(...surfaces.map(sf => this.contrastRatio(c, sf)));
    const brand = this.toRgb(this.settingsData?.merchandise_font_main_color);
    if (brand && minContrast(brand) >= 3) return this.settingsData.merchandise_font_main_color;
    return minContrast([0, 0, 0]) >= minContrast([255, 255, 255]) ? '#000000' : '#ffffff';
  }

  private toRgb(hex: string): number[] {
    const m = /^#?([0-9a-f]{6})$/i.exec((hex || '').trim());
    if (!m) return null;
    const n = parseInt(m[1], 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }

  private luminance([r, g, b]: number[]): number {
    const lin = (c: number) => { c /= 255; return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); };
    return 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
  }

  private contrastRatio(a: number[], b: number[]): number {
    const [hi, lo] = [this.luminance(a), this.luminance(b)].sort((x, y) => y - x);
    return (hi + 0.05) / (lo + 0.05);
  }

  populateBillingAddress(event) {
    if (event.checked)
      this.sameBillingAddress = true;
    else
      this.sameBillingAddress = false;
    if (event.checked)
      this.getBillingAddress(this.shippingForm.value, 'billingForm', true);
    else
      this.buildBillingForm();
  }

  setCountry(e: any) {
    if (e.target.value) {
      this.countryChanged = false;
      let selectCountryInfo = this.countriesList.find(c => c.name.toLowerCase() === e.target.value.toLowerCase());
      this.billingForm.get('country').setValue(selectCountryInfo);
      if (selectCountryInfo && selectCountryInfo.alpha2code) {
        this.countryChanged = false;
        this.options = {
          types: [],
          componentRestrictions: { country: selectCountryInfo.alpha2code }
        };
        setTimeout(() => { this.countryChanged = true });
      }
    }
  }
  onPasteLocation(event: ClipboardEvent,formType) {
    let clipboardData = event.clipboardData || window.clipboardData;
    this.pastedText = clipboardData.getData('text');
    this.getSelectedAddress(this.pastedText,formType);
  }

  get getBillingValue() {
    return this.billingForm.getRawValue();
  }

  get getShippingValue() {
    return this.shippingForm.getRawValue();
  }

verifyCoupon() {
    const userId =  this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Applied Coupon Code ${this.couponCode} by ${userId}`, {
      CartId: this.cartId,
    });
    const data = {
      actionType: "product",
    metaData: {
      title: `Applied Coupon Code - code: ${this.couponCode} - cartID: ${this.cartId}`,
      cartId: this.cartId,
      couponCode: this.couponCode,
      productsTotal: this.productsTotal || null,
      finalAmount: this.finalAmount || null,
      currency: this.getCurrency || null,
      timeStamp: new Date().toISOString()
    },
    organizationId: this.commonSubscribeService?.slugInfo?.organization_id || '',
    networkGroupId: this.networkGroupId || null,
    }
    this.commonSubscribeService.sendTriggeredEvent(data);
    if (this.couponCode == '' || this.couponCode == undefined) {
      this.toastr.error("Please enter coupon code");
      return;
    }
    let params = {
      "coupon_code": this.couponCode.toUpperCase(),
      "cart_id": this.cartId,
      "currency": this.productCurrency,
      "exchange_rate": this.USD_Rates && this.USD_Rates[this.productCurrency] ? this.USD_Rates[this.productCurrency] : 1,
      "network_group_id": this.networkGroupId
    }
    let url = API.VERIFY_COUPON;
  this.appPaymentService.postRequest(url, params).subscribe(response => {
      if (response['message'] == 'Success') {
      this.isDiscountApplied = true;
        this.discountAmount = Number(response["total_discount"]);
      this.discountData = response;
        if(this.discountAmount>this.finalAmount){
          this.toastr.error("This coupon code is invalid for this product. Try with another code.");
        this.clearCode();
        }else{
          this.finalAmount = this.finalAmount - this.discountAmount;
      }
      this.calTax();
    } else {
        this.toastr.error(response['message']);
    }
  });
}

  calTax() {
    if ((this.billingForm.valid && (this.shippingForm.valid || !this.showShippingForm)) || ((((Object.keys(this.selectedShippingAddress).length > 0 || this.shippingForm.valid) || !this.showShippingForm) && (Object.keys(this.selectedBillingAddress).length > 0 || this.billingForm.valid)))) {
      this.commonSubscribeService.formsValidationSubject.next(true);
      let country;
      if (this.selectedCard && this.selectedCard.id) {
        this.countriesList.forEach(element => {
          if (element.alpha2code == this.selectedCard.billing_address.country) {
            country = element;
          }
        });
      }
      let zip = this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : ""
      let cName = this.getBillingValue.country.name ? this.getBillingValue.country.name : this.selectedBillingAddress && this.selectedBillingAddress.country ? country ? country.name : this.selectedBillingAddress.country : ""
      this.commonSubscribeService.validateZip(zip, cName, (result) => {
        if (result.status) {
          this.processingFee = 0;
          let zipCode = this.showShippingForm || (this.selectedShippingAddress && this.selectedShippingAddress.zip) ? this.getShippingValue.zip : this.selectedShippingAddress && this.selectedShippingAddress.zip ? this.selectedShippingAddress.zip : zip;
          this.getTaxPercentage(zipCode, () => {
            if(this.digitalProducts && this.digitalProducts.length != this.cartProductsList.length){
              this.shippingCost = this.shippingChrg;
            } else{
              this.shippingCost = 0;
            }
            this.finalAmount = this.productsTotal + this.taxAmount + this.shippingCost - this.discountAmount;
            this.amt_without_pf = this.finalAmount = Number(this.finalAmount.toFixed(2));
            // Processing fee only applies once a payment mode is chosen, and not for wallet/crypto (calFee() follows the same rule).
            if (this.selectedTransaction && this.selectedTransaction != 'wallet' && this.selectedTransaction != 'crypto') {
              this.processingFee = (this.finalAmount * (environment.processing_fee / 100)) + environment.fee_percentage;
              this.processingFee = Number(this.processingFee.toFixed(2));
              this.finalAmount = this.finalAmount + this.processingFee;
            } else {
              this.processingFee = 0;
            }
            this.finalAmount = Number(this.finalAmount.toFixed(2));
            let data = {
              "total_amount":this.finalAmount,
              "currency": this.productCurrency,
              "processing_fee": this.processingFee ? this.processingFee : undefined,
              "amt_without_pf": this.amt_without_pf
            }
            this.commonSubscribeService.totalAmountSubject.next(data);
          });
        } else {
          this.toastr.error('Invalid zip code');
        }
      });
    }else {
      this.finalAmount = this.productsTotal + this.taxAmount + this.shippingCost - this.discountAmount;
      let data = {
              "total_amount": this.productsTotal + this.taxAmount + this.shippingCost - this.discountAmount,
              "currency": this.productCurrency,
              "processing_fee": this.processingFee ? this.processingFee : undefined,
              "amt_without_pf": this.amt_without_pf
            }
            this.commonSubscribeService.totalAmountSubject.next(data);
    }
  }

  clearCode() {
    this.couponCode = "";
    this.isDiscountApplied = false;
    this.discountAmount = 0;
    this.calTax();
  }

  proceedWithAddress() {
    if ((this.billingForm.valid && (this.shippingForm.valid || !this.showShippingForm)) || ((((Object.keys(this.selectedShippingAddress).length > 0 || this.shippingForm.valid) || !this.showShippingForm) && (Object.keys(this.selectedBillingAddress).length > 0 || this.billingForm.valid))))
      this.proceed();
  }

  proceed() {
    if (this.billingForm.invalid) {
      this.getBillingAddress(this.shippingForm.value, 'billingForm', true);
    }
    if (this.digitalProducts.length > 0 && !this.email) {
      this.toastr.error("Please enter email");
      this.commonSubscribeService.formsValidationSubject.next(false);
      return;
    }
    // this.checkShippingPrice();
    this.getBillingValue.currentBlock = "Merch Market";
    this.commonSubscribeService.billingInfoSubject.next(this.getBillingValue);
    if (this.selectedCard && this.selectedCard.id) {
      let card = this.selectedCard.billing_address;
      this.selectedBillingAddress.line1 = card.line1;
      this.selectedBillingAddress.line2 = card.line2;
      this.selectedBillingAddress.city = card.city;
      this.selectedBillingAddress.country = card.country;
      this.selectedBillingAddress.state = card.state;
      this.selectedBillingAddress.zip = card.postal_code;
    }
    if ((this.billingForm.valid && (this.shippingForm.valid || !this.showShippingForm)) || ((((Object.keys(this.selectedShippingAddress).length > 0 || this.shippingForm.valid) || !this.showShippingForm) && (Object.keys(this.selectedBillingAddress).length > 0 || this.billingForm.valid)))) {
      this.commonSubscribeService.formsValidationSubject.next(true);
      let country;
      if (this.selectedCard && this.selectedCard.id) {
        this.countriesList.forEach(element => {
          if (element.alpha2code == this.selectedCard.billing_address.country) {
            country = element;
          }
        });
      }
      let zip = this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : ""
      let cName = this.getBillingValue.country.name ? this.getBillingValue.country.name : this.selectedBillingAddress && this.selectedBillingAddress.country ? country ? country.name : this.selectedBillingAddress.country : ""
      this.commonSubscribeService.validateZip(zip, cName, (result) => {
        if (result.status) {
          this.processingFee = 0;
          this.codes = result;
          let country = COUNTRIES_LIST.filter(country => country.alpha2code == this.codes.country)
          this.codes.country = country[0].alpha3code;
          let zipCode = this.showShippingForm || (this.selectedShippingAddress && this.selectedShippingAddress.zip) ? this.getShippingValue.zip : this.selectedShippingAddress && this.selectedShippingAddress.zip ? this.selectedShippingAddress.zip : zip;
          this.getTaxPercentage(zipCode, () => {
            if(this.digitalProducts && this.digitalProducts.length != this.cartProductsList.length){
              this.shippingCost = this.shippingChrg;
            } else{
              this.shippingCost = 0;
            }
            this.finalAmount = this.productsTotal + this.taxAmount + this.shippingCost - this.discountAmount;
            this.amt_without_pf = this.finalAmount = Number(this.finalAmount.toFixed(2));
            // Processing fee only applies once a payment mode is chosen, and not for wallet/crypto (calFee() follows the same rule).
            if (this.selectedTransaction && this.selectedTransaction != 'wallet' && this.selectedTransaction != 'crypto') {
              this.processingFee = (this.finalAmount * (environment.processing_fee / 100)) + environment.fee_percentage;
              this.processingFee = Number(this.processingFee.toFixed(2));
              this.finalAmount = this.finalAmount + this.processingFee;
            } else {
              this.processingFee = 0;
            }
            this.finalAmount = Number(this.finalAmount.toFixed(2));
            let data = {
              "total_amount": this.finalAmount,
              "currency": this.productCurrency,
              "processing_fee": this.processingFee ? this.processingFee : undefined,
              "amt_without_pf": this.amt_without_pf
            }
            this.commonSubscribeService.totalAmountSubject.next(data);
          });
        } else {
          this.toastr.error('Invalid zip code');
        }
      });
      if (this.getShippingValue.address1 && this.showShippingForm) {
        this.commonSubscribeService.validateZip(this.getShippingValue.zip, this.getShippingValue.country.name, (result) => {
          if (result.status) {
            this.shippingCodes = result;
            let country = COUNTRIES_LIST.filter(country => country.alpha2code == this.shippingCodes.country);
            this.shippingCodes.country = country[0].alpha3code;
          }
          else {
            this.toastr.error('Invalid zip code');
          }
        });
      }
    } else if (this.shippingForm.invalid && this.showShippingForm && Object.keys(this.selectedShippingAddress).length == 0) {
      this.toastr.error('Please fill shipping information');
      this.commonSubscribeService.scrollToError();
      this.commonSubscribeService.markFormGroupTouched(this.shippingForm);
      return;
    } else if (this.billingForm.invalid && Object.keys(this.selectedShippingAddress).length == 0) {
      this.toastr.error('Please fill billing information');
      this.commonSubscribeService.scrollToError();
      this.commonSubscribeService.markFormGroupTouched(this.billingForm);
      return;
    }
  }

  getTaxPercentage(zip, callback) {
    let addOnAmount = 0;
    this.cartProductsList.forEach(element => {
      if (element.product_info.is_taxable) {
        addOnAmount += element.totalPrice;
      }
    });
    if(this.digitalProducts && this.digitalProducts.length != this.cartProductsList.length){
      this.shippingCost = this.shippingChrg;
    } else{
      this.shippingCost = 0;
    }
    if (addOnAmount) {
      addOnAmount = addOnAmount - this.discountAmount;
      if (this.showShippingForm) {
        addOnAmount = addOnAmount + this.shippingCost;
      }
      // this.processingFee = (addOnAmount * (2.9 / 100)) + 0.3;
      // this.processingFee = Number(this.processingFee.toFixed(2));
      // addOnAmount = addOnAmount + this.processingFee;
      addOnAmount = Number(addOnAmount.toFixed(2));
    }
    if (addOnAmount > 0) {
      let data: any = {
        access_token: this.userInfo.access_token,
        amount: 0,
        // liveAmount: liveAmount,
        // stream_id: this.streamId,
        payment_type: 'order',
        currency: this.productCurrency,
        address: {
          street1: this.getBillingValue.address1,
          city: this.getBillingValue.city,
          state: this.getBillingValue.state,
          state_code: this.codes.state,
          zip: this.getBillingValue.zip,
          country: this.getBillingValue.country.name,
          country_code: this.codes.country
        },
        addOnAmount: addOnAmount
      };
      this.paymentService.calculateTax(data, (result) => {
        if (result.status == 0) {
          this.taxPercentage = result.data.taxPercentage;
          this.taxAmount = result.data.tax;
          this.taxAmount = Number(this.taxAmount.toFixed(2));
          this.finalAmount = result.data.finalAmount;
          this.finalAmount = this.productsTotal + this.taxAmount + this.shippingCost - this.discountAmount;
          this.finalAmount = Number(this.finalAmount.toFixed(2));
          this.invoice_id = result.data.invoice_id;
          this.incl = result.data.incl;
          if (this.incl)
            this.taxAmount = 0;
          callback();
        } else {
          this.toastr.error('Unable to get tax');
        }
      })
    }
    else {
      this.taxPercentage = 0;
      this.taxAmount = 0;
      this.finalAmount = this.productsTotal + this.taxAmount + this.shippingCost - this.discountAmount;
      this.finalAmount = Number(this.finalAmount.toFixed(2));
      this.invoice_id = '';
      this.incl = '';
      this.cd.detectChanges();
      callback();
    }
  }

  calFee(response) {
    if(this.digitalProducts && this.digitalProducts.length != this.cartProductsList.length){
      this.shippingCost = this.shippingChrg;
    } else{
      this.shippingCost = 0;
    }
    this.selectedTransaction = response.selectedTransaction;
    if (this.currentBlock == "Merch Market") {
      this.selectedTransaction = response.selectedTransaction;
      this.amt_without_pf = this.productsTotal + this.taxAmount + this.shippingCost - this.discountAmount;
      if (this.selectedTransaction == "wallet" || this.selectedTransaction == "crypto") {
        this.processingFee = 0;
        this.finalAmount = this.amt_without_pf;
      } else if (this.selectedTransaction && this.selectedTransaction != "wallet") {
        this.processingFee = (this.amt_without_pf * (environment.processing_fee / 100)) + environment.fee_percentage;
        this.processingFee = Number(this.processingFee.toFixed(2));
        this.finalAmount = this.amt_without_pf + this.processingFee;
      }
      let data = {
        "total_amount": this.finalAmount,
        "currency": this.productCurrency,
        "processing_fee": this.processingFee ? this.processingFee : undefined,
        "amt_without_pf": this.amt_without_pf
      }
      this.commonSubscribeService.totalAmountSubject.next(data);
    }
  }

  async makePayment(from?) {
    try { fbq('track', 'StripePay'); } catch (e) { }
    let amount, name;
    amount = this.productsTotal;
    name = this.userInfo.user_display_name || this.userInfo.display_name

    if (this.transactionInfo["card"] || from == 'card' || this.transactionInfo["mode"]) {
      document.getElementById('shipping-product').scrollIntoView({ behavior: 'smooth' });
      this.toggleLoader('');
      this.paymentDetails();
      // let checkoutUrl = API.INITIATE_CHECKOUT + '?NOLOADER';
      // let params = { "stream_id": this.streamId }
      // this.appPaymentService.postRequest(checkoutUrl, params).subscribe(result => {
      //   if (result['status'] == 0 && result.message == 'Success') {
      //     this.paymentDetails();
      //   } else {
      //     if (result.message.includes('discount')) {
      //       this.toastr.info(result.message)
      //       this.openDialog('', 'checkout');
      //     } else {
      //       this.toastr.info(result.message);
      //     }
      //   }
      // });



    }
  }

  paymentResp: any;
  cartUrl: any;
  isPayment: boolean = false;
  paymentDetails() {
    this.isPayment = true;
    this.cartUrl = '';
    let amount, name;
    amount = this.productsTotal;
    name = this.userInfo.user_display_name || this.userInfo.display_name;
    // let id = this.route.snapshot.params.eventId ? this.route.snapshot.params.eventId.split('-') : "";
    // let eventId = id && id[0] ? id[0] : this.streamInfo.parent_streams_id;
    let paymentParams = {
      // "event_id": Number(eventId),
      // "stream_id": this.streamId,
      "cart_id": this.cartId,
      "currency": this.transactionInfo.currency ? this.transactionInfo.currency : this.productCurrency.toLowerCase() || 'gbp',
      "total_price": this.selectedTransaction == "crypto" ? this.crypto_amount : this.finalAmount,
      "creator_currency": this.creator_currency
    }
    paymentParams['billing_address'] = {
      line1: this.getBillingValue.address1 ? this.getBillingValue.address1 : this.selectedBillingAddress && this.selectedBillingAddress.line1 ? this.selectedBillingAddress.line1 : "",
      line2: this.getBillingValue.address2 ? this.getBillingValue.address2 : this.selectedBillingAddress && this.selectedBillingAddress.line2 ? this.selectedBillingAddress.line2 : "",
      city: this.getBillingValue.city ? this.getBillingValue.city : this.selectedBillingAddress && this.selectedBillingAddress.city ? this.selectedBillingAddress.city : "",
      state: this.getBillingValue.state ? this.getBillingValue.state : this.selectedBillingAddress && this.selectedBillingAddress.state ? this.selectedBillingAddress.state : "",
      state_code: this.codes && this.codes.state ? this.codes.state : this.selectedBillingAddress && this.selectedBillingAddress.state_code ? this.selectedBillingAddress.state_code : "",
      zip: this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : "",
      country: this.getBillingValue.country.name ? this.getBillingValue.country.name : this.selectedBillingAddress && this.selectedBillingAddress.country ? this.selectedBillingAddress.country : "",
      country_code: this.codes && this.codes.country ? this.codes.country : this.selectedBillingAddress && this.selectedBillingAddress.country_code ? this.selectedBillingAddress.country_code : "",
    };
    let phnNum = this.getShippingValue.phone_number;
    let num = (phnNum && phnNum.number) ? phnNum.number.replace(/\W+/g, '') : '';
    let dial_code = phnNum && phnNum.dialCode;
    let selShipNum = this.selectedShippingAddress && this.selectedShippingAddress.mobile ? this.selectedShippingAddress.dial_code + this.selectedShippingAddress.mobile : "";
    if (this.showShippingForm) {
      paymentParams['shipping_address'] = {
        line1: this.getShippingValue.address1 ? this.getShippingValue.address1 : this.selectedShippingAddress && this.selectedShippingAddress.line1 ? this.selectedShippingAddress.line1 : '',
        line2: this.getShippingValue.address2 ? this.getShippingValue.address2 : this.selectedShippingAddress && this.selectedShippingAddress.line2 ? this.selectedShippingAddress.line2 : '',
        city: this.getShippingValue.city ? this.getShippingValue.city : this.selectedShippingAddress && this.selectedShippingAddress.city ? this.selectedShippingAddress.city : "",
        state: this.getShippingValue.state ? this.getShippingValue.state : this.selectedShippingAddress && this.selectedShippingAddress.state ? this.selectedShippingAddress.state : "",
        state_code: this.codes && this.codes.state ? this.codes.state : this.selectedShippingAddress && this.selectedShippingAddress.state_code ? this.selectedShippingAddress.state_code : "",
        zip: this.getShippingValue.zip ? this.getShippingValue.zip : this.selectedShippingAddress && this.selectedShippingAddress.zip ? this.selectedShippingAddress.zip : "",
        country: this.getShippingValue.country.name ? this.getShippingValue.country.name : this.selectedShippingAddress && this.selectedShippingAddress.country ? this.selectedShippingAddress.country : "",
        country_code: this.codes && this.codes.country ? this.codes.country : this.selectedShippingAddress && this.selectedShippingAddress.country ? this.selectedShippingAddress.country : "",
        phone_number: dial_code && num ? dial_code + num : selShipNum
      };
    }
    paymentParams['processing_fee'] = this.processingFee;
    paymentParams['tax_amount'] = this.taxAmount;
    paymentParams['tax_percentage'] = this.taxPercentage;
    paymentParams['shipping_cost'] = this.shippingCost ? this.shippingCost : undefined;
    // paymentParams['discount_amount'] = this.discountAmount ? this.discountAmount : undefined;
    if (this.paymentResp) {
      paymentParams['transaction_id'] = this.paymentResp['transaction_id'];
      paymentParams['client_secret'] = this.paymentResp['client_secret'];
      paymentParams['order_id'] = this.paymentResp['order_id'];
    }
    if (this.digitalProducts.length > 0) {
      paymentParams['email'] = this.email;
    }
    paymentParams['invoice_id'] = this.invoice_id ? this.invoice_id : undefined;

    let code;
    if (this.selectedBillingAddress && this.selectedBillingAddress.line1) {
      code = this.selectedBillingAddress.country_code ? this.selectedBillingAddress.country_code : this.selectedBillingAddress.country
      let country;
      if (this.selectedBillingAddress.country_code) {
        country = COUNTRIES_LIST.filter(country => country.alpha3code == code);
      } else if (this.selectedBillingAddress.country) {
        country = COUNTRIES_LIST.filter(country => country.alpha2code == code);
      }
      code = country[0].alpha2code;
    }
    let billingAddress;
    billingAddress = {
      'line1': paymentParams['billing_address'].line1,
      'line2': paymentParams['billing_address'].line2,
      'city': paymentParams['billing_address'].city,
      'state': paymentParams['billing_address'].state,
      'country': this.getBillingValue.country.alpha2code ? this.getBillingValue.country.alpha2code : code ? code : "",
      'postal_code': paymentParams['billing_address'].zip
    }
    let cardInfo = {
      'card': this.card,
      'billing_details': {
        'name': name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name,
        'address': billingAddress
      }
    }
    if (this.userInfo && !this.userInfo.is_guest) {
      if (this.getBillingValue.address1 && this.showBillingForm) {
        paymentParams['new_billing'] = {
          "type": 'billing',
          "name": name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name,
          "line1": this.getBillingValue.address1,
          "line2": this.getBillingValue.address2,
          "city": this.getBillingValue.city,
          "state": this.getBillingValue.state,
          "state_code": this.codes.state,
          "country": this.getBillingValue.country.name,
          "country_code": this.codes.country,
          "zip": this.getBillingValue.zip,
          "remove_default": false,
          "default": false,
          "organization_id": this.organizationId || null,
        }
      }
      if ((this.getShippingValue.address1 && this.showShippingForm) && (!this.selectedShippingAddress || Object.keys(this.selectedShippingAddress).length == 0)) {
        let phnNum = this.getShippingValue.phone_number;
        let num = (phnNum && phnNum.number) ? phnNum.number.replace(/\W+/g, '') : '';
        let dial_code = phnNum && phnNum.dialCode;
        paymentParams['new_shipping'] = {
          "type": 'shipping',
          "name": name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name,
          "mobile": num,
          "dial_code": dial_code,
          "line1": this.getShippingValue.address1,
          "line2": this.getShippingValue.address2,
          "city": this.getShippingValue.city,
          "state": this.getShippingValue.state,
          "state_code": this.shippingCodes ? this.shippingCodes.state : "",
          "country": this.getShippingValue.country.name,
          "country_code": this.shippingCodes ? this.shippingCodes.country : "",
          "zip": this.getShippingValue.zip,
          "remove_default": false,
          "default": false,
          "organization_id": this.organizationId || null,
        }
      }
    }
    paymentParams["network_group_id"] = this.networkGroupId;
    paymentParams["organization_id"] = this.organizationId;
    paymentParams["transaction_amount"] = this.transactionInfo['transaction_amount'];
    paymentParams["payment_gateway"] = this.transactionInfo['mode'] == 'wallet' ? "wallet" : this.transactionInfo['mode'] == 'crypto' ? 'crypto' : undefined;
    paymentParams["crypto_wallet_id"] = this.transactionInfo.crypto_wallet_id ? this.transactionInfo.crypto_wallet_id : undefined;
    // paymentParams["stream_video_title"] = this.streamInfo.stream_video_title;
    paymentParams['amount'] = amount;
    if((paymentParams['referral_code']===undefined || paymentParams["referral_code"]===null) && localStorage.getItem('affiliateReferralCode')){
      const referralCode = localStorage.getItem('affiliateReferralCode');
      paymentParams['referral_code'] = referralCode && referralCode != "undefined" ? JSON.parse(referralCode) : '';
    }
    paymentParams['exchange_rate']=this.curExchangeRate;

    if(this.isDiscountApplied){
      paymentParams['discount_code'] = this.couponCode?this.couponCode:'';

      const discountValue = this.discountData?.coupon_discount_value ?? 0;
      const discountType = this.discountData?.discount_type;   
      paymentParams['discount_type'] = discountType;
      
      if (discountType === 'Amount') {
        paymentParams['discount_amount'] = discountValue;
      } else if (discountType === 'Percentage') {
        paymentParams['discount_percentage'] = discountValue;
      }
    }
    let paymentUrl = MERCH_API.PAYMENT_INITIATE + '?NOLOADER';
    if (this.transactionInfo['mode'] == 'wallet' || this.transactionInfo['mode'] == "crypto") {
      this.appPaymentService.postRequest(paymentUrl, paymentParams).subscribe(result => {
        if (result['status'] == 0 && result['message'] == "Success") {
          if (result['status'] == 0) {
            this.paymentResp = result;
            paymentParams['transaction_id'] = result['transaction_id'];
            this.transactionInfo['id'] = result['id'] ? result['id'] : result['client_secret'];
            this.completeTransaction(paymentParams, this.transactionInfo["paymentIntent"]);
            return;
            // this.loader.start();

          } else {
            this.showOverlay = false;
            this.toggleLoader('none');
            this.commonSubscribeService.sendPaymentStatus(false);
            try { fbq('track', 'StripeInitFailed'); } catch (e) { }
            this.toastr.error(result.message)
            this.loader.stop();
          }
        } else {
          this.toastr.error(result["message"]);
          let errors = result["errors"];
          if (errors && Object.keys(errors).length > 0) {
            this.cartProductsList.forEach(e => {
              for (const [key, value] of Object.entries(errors)) {
                if (key == e.id) {
                  e.invNotAvailable = true;
                  e.inventory = value["inventory"];
                }
              }
            })
            // const sorted = this.cartProductsList.sort((a, b) => a.invNotAvailable ? -1 : 1);
            // this.cartProducts = sorted;
            // this.showAddressForms = false;
            // this.showPaymentForm = false;
            // this.activeBlock = "Merchandise";
            // this.continueSession = true;
            // this.cartUrl = environment.CONSUMER_PORTAL + 'event/stream/' + this.ticket_key + '/errors/' + JSON.stringify(errors) + '?stage=' + this.streamId;
          }
          this.showOverlay = false;
          this.toggleLoader('none');
        }
      });
      return;
    }
    this.appPaymentService.postRequest(paymentUrl, paymentParams).subscribe(result => {
      if (result['status'] == 0 && result['message'] == "Success") {
        if (result['status'] == 0) {
          this.paymentResp = result;
          paymentParams['transaction_id'] = result['transaction_id'];
          // this.loader.start();
          this.transactionInfo.stripe.confirmCardPayment(result['client_secret'], {
            payment_method: this.selectedCard && Object.keys(this.selectedCard).length > 0 ? this.selectedCard.id : cardInfo,
            setup_future_usage: this.selectedCard && Object.keys(this.selectedCard).length > 0 ? undefined : 'off_session'
            // payment_method: {
            //   card: this.card,
            //   billing_details: {
            //     name: name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name
            //   }
            // }
          }).then((result) => {
            console.log(result);
            if (result.error) {
              this.toggleLoader('none');
              this.showOverlay = false;
              this.isPayment = false;
              // Show error to your customer (e.g., insufficient funds)
              this.toastr.error(result.error.message);
            } else {
              // The payment has been processed!

              if (result.paymentIntent.status === 'succeeded') {
                try { fbq('track', 'StripePaymentSuccess'); } catch (e) { }
                this.transactionInfo['id'] = result.paymentIntent.id;
                this.completeTransaction(paymentParams, result.paymentIntent);
              }
            }
            this.toggleLoader('none');
          });
        } else {
          this.showOverlay = false;
          this.toggleLoader('none');
          this.commonSubscribeService.sendPaymentStatus(false);
          try { fbq('track', 'StripeInitFailed'); } catch (e) { }
          this.toastr.error(result.message)
          this.loader.stop();
        }
      } else {
        this.toastr.error(result["message"]);
        let errors = result["errors"];
        if (errors && Object.keys(errors).length > 0) {
          this.cartProductsList.forEach(e => {
            for (const [key, value] of Object.entries(errors)) {
              if (key == e.id) {
                e.invNotAvailable = true;
                e.inventory = value["inventory"];
              }
            }
          })
        }
        this.showOverlay = false;
        this.toggleLoader('none');
      }
    });
  }

  completeTransaction(paymentParams, result) {
    let paramValues = {
      id: this.transactionInfo['id'] ? this.transactionInfo['id'] : this.paymentResp['client_secret'],
      currency: this.transactionInfo.currency ? this.transactionInfo.currency : this.productCurrency,
      creator_currency: this.creator_currency,
      card_id: this.transactionInfo['save_card'] ? result.payment_method : undefined,
      new_shipping: paymentParams['new_shipping'] ? paymentParams['new_shipping'] : undefined,
      new_billing: paymentParams['new_billing'] ? paymentParams['new_billing'] : undefined,
    }
    if (this.organization_product_details) {
      paramValues["organization_product_details"] = this.organization_product_details;
    }
    paramValues["payment_gateway"] = this.transactionInfo['mode'] == 'wallet' ? "wallet" : this.transactionInfo['mode'] == 'crypto' ? 'crypto' : undefined;
    paramValues["transaction_amount"] = this.transactionInfo['transaction_amount'];
    paramValues["crypto_wallet_id"] = this.transactionInfo.crypto_wallet_id ? this.transactionInfo.crypto_wallet_id : undefined;
    paramValues["network_group_id"] = this.networkGroupId || null;
    paramValues["organization_id"] = this.organizationId;
    let url = MERCH_API.PAYMENT_COMPLETE + '?NOLOADER';
    this.appPaymentService.postRequest(url, paramValues).subscribe(result => {
      if (result['status'] == 0 && result['message'] == "Success") {
        this.showOverlay = false;
        if (this.activatedRoute.snapshot.queryParams.token) {
          this.isMobPaymentSuccess = true;
        }
        this.toastr.success("Payment completed successfully");
        this.merchCartService.removeFromWishlist((this.cartProductsList || []).map(item => item.product_id), this.userInfo?.access_token);
        if (!this.activatedRoute.snapshot.queryParams.token) {
          this.openDialog();
          this.commonSubscribeService.cartRefreshSubject.next({ 'is_refresh': true });
        }
        this.isPayment = false;
        this.commonSubscribeService.updateAvailBalSubject.next(true);
        // this.getShoppingCartList();
      } else {
        try { fbq('track', 'StripePaymentFailed'); } catch (e) { }
        this.showOverlay = false;
        this.toastr.error(result['message']);
      }

    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ProductConfirmationDialog, {
      panelClass: 'product-confirmation-dialog',
      disableClose: true,
      // data: data
      data: this.channelName
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  showOverlay: boolean = false;
  timer = 120;
  toggleLoader(state) {
    if (state != 'none') {
      this.showOverlay = true;
      var counter = 120;
      var interval = setInterval(() => {
        counter--;
        if (counter <= 0) {
          clearInterval(interval);
          return;
        } else {
          this.timer = counter;
        }
      }, 1000);
    }
    if (state == 'none') {
      this.loader.stop();
    }
  }

  redirectTo() {
    this.deviceInfo = this.commonSubscribeService.getMobileOperatingSystem();
    if(this.deviceInfo == 'web'){
      if (this.isMerchandiseFlow()) {
        this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName) + '/merchandise/product-cart/' + this.cartId]);
      } else {
        this.router.navigateByUrl('/network-market/product-cart/' + this.cartId);
      }
    }
  }

  isMerchandiseFlow(): boolean {
  return this.router.url.includes('/merchandise');
}

  goToMarketPlace(){
    const currentUrl = this.router.url;

    // detect merchandise flow
    const isMerchandise = currentUrl.includes('/merchandise');
    console.log("currentUrl:", currentUrl, "isMerchandise:", isMerchandise);

    // decide base route
    const base = isMerchandise
      ? '/network-market/merchandise/merch-list'
      : '/network-market/market';
      console.log('Navigating to:', base);

    this.router.navigateByUrl(base);
  }

  preventInvalidSpaces(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.preventDefault();
    }
  }
  
  onCouponInput(value: string) {
    this.couponCode = value.replace(/\s+/g, '').toUpperCase();
  }
  
  onCouponPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pasted = event.clipboardData?.getData('text') ?? '';
    this.couponCode = pasted
      .replace(/\s+/g, '')
      .toUpperCase();
  }

  ngOnDestroy() {
    this.userInfoSubscription?.unsubscribe();
    this.addressListInfoSubscr?.unsubscribe();
    this.transactionInfoSubscr?.unsubscribe();
    this.selectedCardInfoSubscr?.unsubscribe();
    this.settingsDataSubscription?.unsubscribe();
    this.performerInfoSubscription?.unsubscribe();
  }

}

@Component({
  selector: 'app-product-confirmation-dialog',
  templateUrl: './product-confirmation-dialog.html',
  styleUrls: ['./shipping-product.component.scss']
})
export class ProductConfirmationDialog implements OnInit {
  channelName: string;
  settingsData: any = {};
  settingsDataSubscription: Subscription;
 
  constructor(private router: Router,
    private route: ActivatedRoute,
    public dialogRef: MatDialogRef<ProductConfirmationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    
    private commonSubscribeService: CommanSubscribeService) {
  }
   ngOnInit(): void {
    this.channelName = this.data || '';
    this.settingsDataSubscription = this.commonSubscribeService.getICWebpageThemeSettings().subscribe(async (response) => {
      this.settingsData = response;
    });
    this.settingsData = this.commonSubscribeService.icWebpageSettingsData;
  }

  redirectToHome() {
    this.commonSubscribeService.getCartProdCountApiCallSubject.next(true);
    const currentUrl = this.router.url;
    // detect merchandise flow
    const isMerchandise = currentUrl.includes('/merchandise');
    // decide base route
    const base = isMerchandise
      ? `${this.commonSubscribeService.getChannelBasePath(this.channelName)}/merchandise/merch-list`
      : '/network-market/market';
    this.router.navigateByUrl(base);
    this.dialogRef.close();
  }

}